<div class="flex items-center flex-col m-4">
  <lib-svg
    [svg]="brandService.isYallo() ? 'reset-password' : 'reset-password-lebara'"
    class="w-32 [&_svg]:size-full"
  ></lib-svg>
</div>

<div class="flex flex-col items-center mt-8 text-wrap">
  <h2 class="font-bold text-base leading-6 text-center">
    {{ ['login', 'reset_password_title'] | translate }}
  </h2>

  <div class="mt-4 text-center">
    <ngx-dynamic-hooks
      [content]="['login', 'reset_password_disclaimer'] | translate | replaceToken: { method: loginValue }"
      [options]="{ sanitize: false }"
    ></ngx-dynamic-hooks>
  </div>
</div>
